
import {
  IconChargingWire,
  IconQuality,
  IconWarning,
} from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'
import IllustrationDeviceSmartphone from '@core/illustrations/IllustrationDeviceSmartphone.svg'
import { productExcludedAccessoriesFetch } from '@http/endpoints'

import ContentRowModal from '../ContentRowModal'

const ICONS = {
  IconChargingWire,
  IconQuality,
  IconWarning,
}

const ILLUSTRATIONS = {
  IllustrationDeviceSmartphone,
}

export default {
  components: {
    ContentRowModal,
  },
  data() {
    return {
      accessories: {},
      isLoading: true,
      hasError: false,
    }
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
    }),

    modalName: () => MODAL_NAMES.PRODUCT.EXCLUDED_ACCESSORIES,

    modalTitle() {
      return this.accessories.title
    },

    excludedAccessories() {
      return this.accessories.paragraphs?.map(({ icon, title, text }) => ({
        icon: ICONS[icon],
        labels: [text],
        title,
      }))
    },
    illustration() {
      return ILLUSTRATIONS[this.accessories.image]
    },

    productId() {
      return this.$route.params.uuid
    },
  },
  methods: {
    async fetchExcludedAccessories() {
      try {
        const { payload } = await this.$store.dispatch('http/request', {
          request: productExcludedAccessoriesFetch,
          pathParams: { productId: this.productId },
        })

        this.accessories = { ...payload }
        this.isLoading = false
      } catch {
        this.isLoading = false
        this.hasError = true
      }
    },

    onModalClose() {
      this.isLoading = true
      this.hasError = false
    },
  },
}
